import Container from '@components/common/Container';
import { Wrapper } from './JoinUs.styles';
import Link from '@components/common/Link';

export default function JoinUs() {
  return (
    <Container>
      <Wrapper>
        <h4>
          We&apos;re looking
          <br />
          to grow our team
        </h4>
        <p>Want to join us?</p>
        <Link href="https://careers.archimedesfi.com" target="_blank" rel="noreferrer" variant="button">
          View Open Positions
        </Link>
      </Wrapper>
    </Container>
  );
}
